import { View, Pressable } from 'react-native'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import Gradient from '@ui/effects/Gradient'
import { colors } from '@ui/colors'
import { interpolate, useAnimatedStyle } from 'react-native-reanimated'
import cn from '@ui/utils/cn'
import Typography from '@ui/typography'
import Border from '@ui/effects/Border'
import { OrderItem } from '@order/orderTypes'
import { useTranslation } from 'react-i18next'
import { Image } from 'expo-image'

import { sContainer, sInner } from './styles'
import Separator from './Separator'

interface Props {
  number: number
  data: OrderItem
  onPress: () => void
}

export default function OrderGlasses({ number, data, onPress }: Props) {
  const { t } = useTranslation(['ui', 'status'])
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { frame } = data

  const stylePress = useAnimatedStyle(() => ({
    opacity: interpolate(animation.value, [0, 1], [0, 1]),
    borderRadius: 0,
  }))

  return (
    <Pressable
      onPress={onPress}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      className="relative inset-0 flex-1"
    >
      <View className={sContainer}>
        <Separator />
        <Gradient
          colors={[
            colors.gray[200],
            colors.gray[100],
            colors.white0,
            colors.white,
          ]}
          start={[0, 0.5]}
          end={[1, 0.5]}
          style={stylePress}
        />
        <View className={cn(sInner, 'flex-1')} style={{ paddingLeft: 96 }}>
          <View className="h-8 w-8 items-center justify-center rounded-full">
            <View className="flex h-7 w-7 items-center justify-center rounded-full">
              <Border className="border-text border-2" />
              <Typography variant="SMB">{number}</Typography>
            </View>
          </View>
          <View className="flex flex-row items-center gap-4">
            <Typography variant="MDB" color={colors.text}>
              {t('common:glassesNumber', { number })}
            </Typography>
            <Typography variant="MD" color={colors.text50}>
              {frame?.default_code || frame?.id}
            </Typography>
          </View>
        </View>
        <View className={sInner} style={{ paddingRight: 112 }}>
          {frame && (
            <Image
              contentFit="contain"
              style={{ width: 128, height: 64 }}
              source={{ uri: frame.url }}
            />
          )}
        </View>
      </View>
    </Pressable>
  )
}
